'use client';

import { useTheme } from '@mui/material';
import { useDeviceType } from '@packages/shared/src/hooks/useDeviceType/useDeviceType';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

import { useIsCheckoutRoute } from './useIsCheckoutRoute';
import { AccountSlot } from './AccountSlot';
import { BasketSlot } from './BasketSlot';
import { SearchSlot } from './SearchSlot';
import { WishlistSlot } from './WishlistSlot';
import { ServiceSlot } from './ServiceSlot';
import { LocaleSwitchSlot } from './LocaleSwitchSlot';
import { PaybackSlot } from './PaybackSlot';
import { JoeSlot } from './JoeSlot';
import { SlotsContainer } from './SlotsContainer';

export const SlotsDefault = () => {
  const {
    headerSlots: { payback, localeSwitcher, joe, serviceApi },
  } = useConfig();
  const { isMobile } = useDeviceType();
  const isCheckoutRoute = useIsCheckoutRoute();
  const theme = useTheme();

  return (
    <SlotsContainer>
      {localeSwitcher && (
        // workaround: legacy fragment-header used a confusing mess of nth selectors and overrides
        // proper solution needs UI layout redesign
        <LocaleSwitchSlot sx={{ [theme.breakpoints.down(420)]: { display: 'none' } }} />
      )}
      {payback && <PaybackSlot />}
      {joe && <JoeSlot />}
      {!isMobile && serviceApi && <ServiceSlot />}
      {/* workaround: legacy fragment-header used (max-width: 374px) with inverted logic */}
      {/* proper solution needs UI layout redesign */}
      <AccountSlot sx={{ [theme.breakpoints.down(375)]: { display: 'none' } }} />
      {!isCheckoutRoute && <SearchSlot />}
      <WishlistSlot />
      <BasketSlot />
    </SlotsContainer>
  );
};
